import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

// counts: { paid, pending, failed, other }
const StatusDonut = ({ counts = { paid: 0, pending: 0, failed: 0, other: 0 } }) => {
  const total = counts.paid + counts.pending + counts.failed + counts.other;
  const slices = [
    { name: 'Paid', value: counts.paid, color: '#16a34a' },
    { name: 'Pending', value: counts.pending, color: '#f59e0b' },
    { name: 'Failed', value: counts.failed, color: '#dc2626' },
    { name: 'Other', value: counts.other, color: '#94a3b8' },
  ].filter((s) => s.value > 0);

  return (
    <div>
      <div className="relative" style={{ height: 160 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={slices.length ? slices : [{ name: 'None', value: 1, color: '#e2e8f0' }]}
                 dataKey="value" nameKey="name" innerRadius={52} outerRadius={78} paddingAngle={slices.length > 1 ? 2 : 0} stroke="none">
              {(slices.length ? slices : [{ color: '#e2e8f0' }]).map((s, i) => <Cell key={i} fill={s.color} />)}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-xl font-outfit font-bold text-slate-900">{total}</span>
          <span className="text-[10px] text-slate-400">total</span>
        </div>
      </div>
      <div className="mt-3 space-y-1.5">
        {[
          { label: 'Paid', value: counts.paid, color: '#16a34a' },
          { label: 'Pending', value: counts.pending, color: '#f59e0b' },
          { label: 'Failed', value: counts.failed, color: '#dc2626' },
          ...(counts.other ? [{ label: 'Other', value: counts.other, color: '#94a3b8' }] : []),
        ].map((r) => (
          <div key={r.label} className="flex items-center justify-between text-xs font-jakarta">
            <span className="flex items-center gap-2 text-slate-600">
              <span className="w-2.5 h-2.5 rounded-sm" style={{ background: r.color }} />{r.label}
            </span>
            <span className="font-semibold text-slate-900">{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusDonut;
